// import { useRef } from 'react';
import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import HomeCompStore from '@src/pages/main/components/home/store';
import PublicBetaStore from '@src/pages/main/components/public-beta/store';
import CharacteristicsStore from '@src/pages/main/components/characteristics/store';
import IntroducedStore from '@src/pages/main/components/introduced/store';
import AttentionStore from '@src/pages/main/components/attention/store';

import PageChangeStore from './store/page-change';
import LoadComponentsStore from './store/load-components';
import NavbarStore from '@src/business-components/navbar/store';

import useModal from '@src/utils/hooks/use-modal';
import QrcodeModalStore from '@src/business-components/modal/qrcode-modal/store';
// import QrcodeModal from '@src/business-components/modal/qrcode-modal';
import FormModalStore from '@src/business-components/modal/form-modal/store';
// import FormModal from '@src/business-components/modal/form-modal';
import SuccessModalStore from '@src/business-components/modal/success-modal/store';
// import SuccessModal from '@src/business-components/modal/success-modal';
import EligibilityInquiryModalStore from '@src/business-components/modal/eligibility-inquiry/store';
// import EligibilityInquiryModal from '@src/business-components/modal/eligibility-inquiry';
import RuleModalStore from '@src/business-components/modal/rule-modal/store';

import { getOmniPosData, ominStaticResPos } from '@src/services/omni-api';
import * as format from './utils/format';
import { getUtmSource } from '@src/utils/device';
import lazyLoadComp from '@src/utils/lazyLoadComp';
import { DOWNLOAD_QR_POSITION, getDownloadQrIframeUrl } from '@src/utils/qr-track-iframe';

const QrcodeModal = lazyLoadComp(() => import('@src/business-components/modal/qrcode-modal'));
const FormModal = lazyLoadComp(() => import('@src/business-components/modal/form-modal'));
const SuccessModal = lazyLoadComp(() => import('@src/business-components/modal/success-modal'));
const EligibilityInquiryModal = lazyLoadComp(() => import('@src/business-components/modal/eligibility-inquiry'));
const RuleModal = lazyLoadComp(() => import('@src/business-components/modal/rule-modal'));

class MainStore extends BaseStore {
  /** 项目基本信息 */
  @observable projectConfig;
  /** 首页omni数据 */
  @observable omniDataKv = {};
  /** 首页omni数据 */
  @observable omniDataHome = {};
  /** 公测活动数据 */
  @observable omniDataPublicBeta = [];
  /** 游戏特色轮播omni数据 */
  @observable omniDataCharacteristics = [];
  /** 游戏精美实录omni数据 */
  @observable omniDataRealMachinePicture = [];
  /** 门派数据 */
  @observable omniDataIntroduced = [];
  /** 鸿蒙客户端下载提示弹窗 */
  @observable isHarmonyDownloadModalOpen = false;

  /** 页面模块切换相关逻辑 */
  pageChangeStore = new PageChangeStore();
  /** 组件加载控制相关逻辑 */
  loadComponentsStore = new LoadComponentsStore();
  /** 导航栏模块相关逻辑 */
  navbarStore = new NavbarStore({
    mainStore: this,
    changeActiveCb: val => {
      this.pageChangeStore.setCurrentPage(val);
    }
  });
  /** 首页模块相关逻辑 */
  homeCompStore = new HomeCompStore({ mainStore: this });
  /** 公开测试模块相关逻辑 */
  publicBetaStore = new PublicBetaStore({ mainStore: this });
  /** 游戏特色模块相关逻辑 */
  characteristicsCompStore = new CharacteristicsStore({ mainStore: this });
  /** 门派介绍模块相关逻辑 */
  introducedCompStore = new IntroducedStore({ mainStore: this });
  /** 关注我们模块相关逻辑 */
  attentionStore = new AttentionStore({ mainStore: this });

  /** 资格查询弹窗模块相关逻辑 */
  eligibilityInquiryModalStore = new EligibilityInquiryModalStore({
    closeCb: () => this.pageChangeStore.unLockScroll()
  });
  /** 活动规则弹窗模块相关逻辑 */
  ruleModalStore = new RuleModalStore({
    closeCb: () => this.pageChangeStore.unLockScroll()
  });
  /** 成功弹窗模块相关逻辑 */
  successModalStore = new SuccessModalStore({
    closeCb: () => this.pageChangeStore.unLockScroll(),
    goToFormModal: () => this.openReservationModal('form')
  });
  /** 二维码弹窗模块相关逻辑 */
  qrcodeModalStore = new QrcodeModalStore({
    closeCb: () => this.pageChangeStore.unLockScroll(),
    goToFormModal: () => this.openReservationModal('form')
  });
  /** 预约弹窗模块相关逻辑 */
  formModalStore = new FormModalStore({
    closeCb: () => this.pageChangeStore.unLockScroll(),
    reservationSuccessCb: () => this.getConfig(),
    goToQrcodeModal: () => this.openReservationModal('qrcode')
  });

  /** 打开预约弹窗 */
  openReservationModal = type => {
    this.pageChangeStore.lockScroll();
    switch (type) {
      case 'success':
        this.modals.success.open();
        return;
      case 'qrcode':
        this.modals.qrcode.open();
        return;
      case 'form':
        this.modals.form.open();
        return;
      default:
        this.modals.form.open();
        return;
    }
  };
  openEligibilityInquiryModal = () => {
    this.pageChangeStore.lockScroll();
    this.modals.inquiry.open();
  };
  /** 打开活动规则弹窗 */
  openRuleModal = () => {
    this.pageChangeStore.lockScroll();
    this.modals.rule.open();
  };
  /** 打开鸿蒙客户端下载提示弹窗 */
  openHarmonyDownloadModal = () => {
    this.pageChangeStore.lockScroll();
    this.isHarmonyDownloadModalOpen = true;
  };
  /** 关闭鸿蒙客户端下载提示弹窗 */
  closeHarmonyDownloadModal = () => {
    this.isHarmonyDownloadModalOpen = false;
    this.pageChangeStore.unLockScroll();
  };

  /** 获取项目配置 */
  getConfig = () => {
    this.$ztService.getConfig().then(config => {
      this.projectConfig = config;
      this.homeCompStore.projectConfig = this.projectConfig;
      // console.log('init this.$ztService.getConfig', this.projectConfig);
    });
  };

  /** 初始化 */
  init = () => {
    // this.openReservationModal('form');
    // this.openEligibilityInquiryModal();

    /** 获取omin配置数据 */
    // 一次性获取所有配置的omin数据
    const utmSource = (getUtmSource('utm_source') || '').trim();
    const params = Object.keys(ominStaticResPos)
      .filter(key => key !== 'home_downloadCustom')
      .map(key => ominStaticResPos[key]);
    const customDownloadParams = {
      ...ominStaticResPos.home_downloadCustom,
      dataSources: ominStaticResPos.home_downloadCustom.dataSources.map(dataSource => ({
        ...dataSource,
        contentFilter: {
          ...dataSource.contentFilter,
          items: dataSource.contentFilter.items.map(item => ({ ...item, value: utmSource }))
        }
      }))
    };
    let customDownloadRequest = Promise.resolve(null);
    if (utmSource) {
      customDownloadRequest = getOmniPosData([customDownloadParams]).catch(error => {
        console.warn('获取 Omni 渠道下载数据失败，已回退默认官包', error);
        return null;
      });
    }

    Promise.all([getOmniPosData(params), customDownloadRequest])
      .then(([result, customDownloadResult]) => {
        const mergedResult = customDownloadResult ? { ...result, data: { ...result.data, ...customDownloadResult.data } } : result;
        const omniDataHome = format.getHomeDataOfOminData(mergedResult, utmSource);
        const downloadLinks = omniDataHome.down_link || {};
        this.omniDataHome = {
          ...omniDataHome,
          down_link: {
            ...downloadLinks,
            indexQrcode: getDownloadQrIframeUrl(downloadLinks.qrcode, DOWNLOAD_QR_POSITION.HOME),
            floatQrcode: getDownloadQrIframeUrl(downloadLinks.qrcode, DOWNLOAD_QR_POSITION.HOME_SIDE)
          }
        };
        this.omniDataPublicBeta = format.getPublicBetaDataOfOminData(mergedResult);
        this.omniDataCharacteristics = format.getCharacteristicsDataOfOminData(mergedResult);
        this.omniDataIntroduced = format.getIntroducedDataOfOminData(mergedResult);
        this.ruleModalStore.setRuleInfo(format.getActivityRuleDataOfOminData(mergedResult));
      })
      .catch(error => {
        console.error('初始化 OMNI 数据失败', error);
      });

    /** 获取项目配置 */
    this.getConfig();

    // 组件加载优化
    this.loadComponentsStore.startDelayedPreload();
    // 通用底部加载配置
    window.init_OMNI__COMMON__FOOTER();
    window.OMNI__COMMON__FOOTER = {
      to_top_handler: () => {
        this.pageChangeStore.toggleFooter(false);
      }
    };
  };
  use() {
    super.use();
    this.pageChangeStore.use();

    this.modals = {
      qrcode: useModal(QrcodeModal, { store: this.qrcodeModalStore }),
      form: useModal(FormModal, { store: this.formModalStore }),
      success: useModal(SuccessModal, { store: this.successModalStore }),
      inquiry: useModal(EligibilityInquiryModal, { store: this.eligibilityInquiryModalStore }),
      rule: useModal(RuleModal, { store: this.ruleModalStore })
    };

    useMount(() => this.init());
  }
}

export default MainStore;
